import { features } from '@/mocks/chiguaData';

export default function FeaturesSection() {
  return (
    <section id="features" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-900 font-heading mb-2">
            为什么选择我们
          </h2>
          <p className="text-sm text-foreground-500">
            91在线吃瓜，吃瓜群众的首选平台
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-4 md:gap-5">
          {features.map((feature) => (
            <div
              key={feature.id}
              className="group rounded-xl bg-background-50 border border-background-200/70 hover:border-accent-200 p-5 md:p-6 text-center transition-colors cursor-pointer"
            >
              <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-accent-50 text-accent-600 group-hover:bg-accent-500 group-hover:text-white transition-colors mb-4 mx-auto">
                <i className={`${feature.icon} text-xl`}></i>
              </div>
              <h3 className="text-base font-semibold text-foreground-900 mb-2">
                {feature.title}
              </h3>
              <p className="text-xs md:text-sm text-foreground-500 leading-relaxed">
                {feature.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}